export default __webpack_public_path__ + "static/media/GREENHOUSE_ICON_GREEN.3d53c36d.svg";